import Common from '../../Common';

interface Search {
	limit?: number,
	limitFrom?: number,
	search?: string,
	orderBy?: string,
	orderDir?: string,
}

interface Profile {
	id: id
	name: string
	pbx_color_id: id
	pbx_icon_id: id
	pbx_user_id: id
	priority: string
}

const Profile = class extends Common {
	browseStandard =
		(companyId: id, search?: Search) => this.get(`/company/${companyId}/profile/standard`, search)

	browse =
		(companyId: id): CustomResponse<{[key: id]: Profile}> => this.get(`/company/${companyId}/profiles`)
}

export default Profile;
